/**
 * Sistema de tema claro/oscuro para la consola de plataforma.
 *
 * Persiste en localStorage como "portal-theme".
 * Default: "light" (paleta del prototipo shell-light.html).
 * El atributo data-theme se aplica a <html> para que afecte a toda la SPA.
 */

export type ConsoleTheme = "dark" | "light";

const STORAGE_KEY = "portal-theme";
const DEFAULT_THEME: ConsoleTheme = "light";

export function getStoredTheme(): ConsoleTheme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "dark" || stored === "light") return stored;
  } catch {
    // localStorage bloqueado (private browsing extremo)
  }
  return DEFAULT_THEME;
}

export function setTheme(theme: ConsoleTheme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // ignorar
  }
  document.documentElement.setAttribute("data-theme", theme);
}

export function initTheme(): ConsoleTheme {
  const theme = getStoredTheme();
  document.documentElement.setAttribute("data-theme", theme);
  return theme;
}
